<template>
  <div class="home">
<!--     <img alt="Vue logo" src="../assets/logo.png"> -->
    <Story title="๑. จกฺขุปาลตฺเถรวตฺถุ." pak="1" wak="1" story="1"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Story from '@/components/Story.vue'

export default {
  name: 'Home',
  components: {
    Story
  }
}
</script>
